
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/who-we-help/business-broker",
      function () {
        return require("private-next-pages/who-we-help/business-broker.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/who-we-help/business-broker"])
      });
    }
  